// DO NOT EDIT -- generated from fs/services/dx-objects/namedelements.proto

import * as protobuf from '../../../google/protobuf';
import * as search_settings from '../search-settings';

export namespace NamedElementsPublic {

  export const ArchiveNamedElementEndpoint = "/grpc/dx_objects.NamedElementsPublic/ArchiveNamedElement";
  /** Archives/unarchives a named element */
  export function ArchiveNamedElement(sender: (req: ArchiveNamedElementRequest, endpoint: string) => Promise<ArchiveNamedElementResponse>, req: ArchiveNamedElementRequest): { promise: () => Promise<ArchiveNamedElementResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveNamedElementEndpoint),
      endpoint: ArchiveNamedElementEndpoint
    };
  }

  export const ArchiveMultiNamedElementsEndpoint = "/grpc/dx_objects.NamedElementsPublic/ArchiveMultiNamedElements";
  /** Archives/unarchives multiple named elements */
  export function ArchiveMultiNamedElements(sender: (req: ArchiveMultiNamedElementsRequest, endpoint: string) => Promise<ArchiveMultiNamedElementsResponse>, req: ArchiveMultiNamedElementsRequest): { promise: () => Promise<ArchiveMultiNamedElementsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveMultiNamedElementsEndpoint),
      endpoint: ArchiveMultiNamedElementsEndpoint
    };
  }

  export const GetAllNamedElementsEndpoint = "/grpc/dx_objects.NamedElementsPublic/GetAllNamedElements";
  /** Gets all named elements */
  export function GetAllNamedElements(sender: (req: GetAllNamedElementsRequest, endpoint: string) => Promise<GetAllNamedElementsResponse>, req: GetAllNamedElementsRequest): { promise: () => Promise<GetAllNamedElementsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllNamedElementsEndpoint),
      endpoint: GetAllNamedElementsEndpoint
    };
  }

  export const GetNamedElementEndpoint = "/grpc/dx_objects.NamedElementsPublic/GetNamedElement";
  /** Get a specific named element at the current version. */
  export function GetNamedElement(sender: (req: GetNamedElementRequest, endpoint: string) => Promise<GetNamedElementResponse>, req: GetNamedElementRequest): { promise: () => Promise<GetNamedElementResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetNamedElementEndpoint),
      endpoint: GetNamedElementEndpoint
    };
  }

  export const SetNamedElementEndpoint = "/grpc/dx_objects.NamedElementsPublic/SetNamedElement";
  /** Sets a named element */
  export function SetNamedElement(sender: (req: SetNamedElementRequest, endpoint: string) => Promise<SetNamedElementResponse>, req: SetNamedElementRequest): { promise: () => Promise<SetNamedElementResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetNamedElementEndpoint),
      endpoint: SetNamedElementEndpoint
    };
  }

  export const SilenceIssueEndpoint = "/grpc/dx_objects.NamedElementsPublic/SilenceIssue";
  /** silences issues for a named element */
  export function SilenceIssue(sender: (req: SilenceIssueRequest, endpoint: string) => Promise<SilenceIssueResponse>, req: SilenceIssueRequest): { promise: () => Promise<SilenceIssueResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SilenceIssueEndpoint),
      endpoint: SilenceIssueEndpoint
    };
  }

  export const UnSilenceIssueEndpoint = "/grpc/dx_objects.NamedElementsPublic/UnSilenceIssue";
  /** silences an issue for a named element */
  export function UnSilenceIssue(sender: (req: UnSilenceIssueRequest, endpoint: string) => Promise<UnSilenceIssueResponse>, req: UnSilenceIssueRequest): { promise: () => Promise<UnSilenceIssueResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnSilenceIssueEndpoint),
      endpoint: UnSilenceIssueEndpoint
    };
  }

  export const ValidateNamedElementEndpoint = "/grpc/dx_objects.NamedElementsPublic/ValidateNamedElement";
  /** Validates a named element */
  export function ValidateNamedElement(sender: (req: ValidateNamedElementRequest, endpoint: string) => Promise<ValidateNamedElementResponse>, req: ValidateNamedElementRequest): { promise: () => Promise<ValidateNamedElementResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ValidateNamedElementEndpoint),
      endpoint: ValidateNamedElementEndpoint
    };
  }

  export const SetSuggestedElementEndpoint = "/grpc/dx_objects.NamedElementsPublic/SetSuggestedElement";
  /** Use to update suggestion status */
  export function SetSuggestedElement(sender: (req: SetSuggestedElementRequest, endpoint: string) => Promise<SetSuggestedElementResponse>, req: SetSuggestedElementRequest): { promise: () => Promise<SetSuggestedElementResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetSuggestedElementEndpoint),
      endpoint: SetSuggestedElementEndpoint
    };
  }

  export const GetSuggestedElementEndpoint = "/grpc/dx_objects.NamedElementsPublic/GetSuggestedElement";
  /** Get a specific element suggestion */
  export function GetSuggestedElement(sender: (req: GetSuggestedElementRequest, endpoint: string) => Promise<GetSuggestedElementResponse>, req: GetSuggestedElementRequest): { promise: () => Promise<GetSuggestedElementResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSuggestedElementEndpoint),
      endpoint: GetSuggestedElementEndpoint
    };
  }
}

export interface NamedElementIssueSilence {
  id: string;
  namedElementId: string;
  expiresAt: protobuf.timestamp | null;
}

/**
 * NamedElementDetail is a seat's view of a Named Element.
 * Currently, it only contains a Named Element record, but in the future it will contain other UI configuration
 * like categorization or view history.
 */
export interface NamedElementDetail {
  namedElement: search_settings.NamedElementRecord | null;
}

export interface SuggestedElementDetail {
  suggestion: search_settings.SuggestionRecord | null;
}

export interface ArchiveNamedElementRequest {
  orgId: string;
  namedElementId: string;
  /** True to archive, false to unarchive */
  archived: boolean;
}

export interface ArchiveNamedElementResponse {
  namedElement: NamedElementDetail | null;
}

export interface ArchiveMultiNamedElementsRequest {
  orgId: string;
  namedElementIds: string[];
  /** True to archive, false to unarchive */
  archived: boolean;
}

export interface ArchiveMultiNamedElementsResponse {
  namedElements: NamedElementDetail[];
}

export interface GetAllNamedElementsRequest {
  orgId: string;
  /** If true, archived named elements will also be returned. */
  includeArchived: boolean;
  includeSuggested: boolean;
}

export interface GetAllNamedElementsResponse {
  namedElements: NamedElementDetail[];
  pendingSuggestedElements: NamedElementDetail[];
  /** The limit of active elements. If length of active (i.e. non archived) elements are at or over limit, new elements will not be allowed. */
  activeLimit: number;
}

export interface GetNamedElementRequest {
  orgId: string;
  namedElementId: string;
  includeSuggested: boolean;
}

export interface GetNamedElementResponse {
  namedElement: NamedElementDetail | null;
}

export interface SetNamedElementRequest {
  orgId: string;
  /**
   * Named element to be created or updated.
   * If the id field is not set, an id will be generated and a named element will be stored.
   * If an id field is set, an existing named element must be in place to perform the update.
   */
  namedElement: search_settings.NamedElement | null;
  /**
   * If set, dedupes create requests containing the same idempotence key.
   * If idempotence key has already been handled, the existing entity will be returned instead of creating a new entity.
   * The idempotence key is only respected on create requests that let the server generate the entity id.
   * Note: This is best effort. Idempotence keys are kept around for three days but may be garbage collected sooner.
   */
  idempotenceKey: string;
  /**
   * When true we know that we can update the element history log to transition an issue
   * from active to pending.
   */
  hasExistingIssue: boolean;
}

export interface SetNamedElementResponse {
  namedElement: NamedElementDetail | null;
}

export interface SilenceIssueRequest {
  orgId: string;
  namedElementId: string;
  expiresAt: protobuf.timestamp | null;
}

export interface SilenceIssueResponse {
  issueSilence: NamedElementIssueSilence | null;
}

export interface UnSilenceIssueRequest {
  orgId: string;
  namedElementId: string;
  issueSilenceId: string;
}

export interface UnSilenceIssueResponse {
  issueSilenceId: string;
  namedElementId: string;
}

export interface ValidateNamedElementRequest {
  orgId: string;
  namedElement: search_settings.NamedElement | null;
}

export interface ValidateNamedElementResponse {
  name: ValidateNamedElementResponse.ValidationState | null;
  platformSelectors: ValidateNamedElementResponse.ValidationState[];
}

export namespace ValidateNamedElementResponse {
  export interface ValidationState {
    valid?: {} | null;
    invalid?: ValidateNamedElementResponse.ValidationState.Error | null;
  }

  export namespace ValidationState {
    export interface Error {
      message: string;
    }

    export enum validation_state {
      valid = 1,
      invalid = 2
    }

    export function validation_state_oneof(m: ValidationState): { opt: validation_state.invalid, val: ValidateNamedElementResponse.ValidationState.Error } | { opt: validation_state.valid, val: {} } | null {
      if (m.valid != null) { return { opt: validation_state.valid, val: m.valid } }
      if (m.invalid != null) { return { opt: validation_state.invalid, val: m.invalid } }
      return null;
    }
  }
}

export interface SetSuggestedElementRequest {
  orgId: string;
  suggestion: search_settings.Suggestion | null;
}

export interface SetSuggestedElementResponse {
  suggestion: SuggestedElementDetail | null;
}

export interface GetSuggestedElementRequest {
  orgId: string;
  elementId: string;
}

export interface GetSuggestedElementResponse {
  suggestion: SuggestedElementDetail | null;
}
